import { library } from '@fortawesome/fontawesome-svg-core';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default function (Vue) {
  library.add(faBars);
  Vue.component('font-awesome-icon', FontAwesomeIcon);
}
